'use strict';

(function (numeral) {
	angular.module('PinMeTo.filters').filter('pmtNumeral', function () {
		return function (input, format) {
			input = input || 0;
			if (format === 'insightsShort') {
				return input >= 1000 ? numeral(input).format('0.0a').toUpperCase() : input;
			}
			return format ? numeral(input).format(format) : input;
		};
	});
})(window.numeral);
